import {
    DASHBOARD_ACTIVITY,
    DASHBOARD_ACTIVITY_ERROR,
    DASHBOARD_ACTIVITY_SUCCESS,
    DASHBOARD_DINNING,
    DASHBOARD_DINNING_ERROR,
    DASHBOARD_DINNING_SUCCESS,
    DASHBOARD_REPAIRS,
    DASHBOARD_REPAIRS_ERROR,
    DASHBOARD_REPAIRS_SUCCESS
} from "../constants/dashboardConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function dashboardReducer(state = initialState, action) {

    switch (action.type) {
        case DASHBOARD_ACTIVITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DASHBOARD',
                'loadingMessage': 'THE DASHBOARD IS BEING LOADED',
                'type': action.type

            });
        case DASHBOARD_ACTIVITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DASHBOARD_ACTIVITY_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardActivityData': action.data,
                'type': action.type

            });
        case DASHBOARD_DINNING:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DASHBOARD',
                'loadingMessage': 'THE DASHBOARD IS BEING LOADED',
                'type': action.type
            });
        case DASHBOARD_DINNING_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DASHBOARD_DINNING_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardDinningData': action.data,
                'type': action.type
            });
        case DASHBOARD_REPAIRS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DASHBOARD',
                'loadingMessage': 'THE DASHBOARD IS BEING LOADED',
                'type': action.type

            });
        case DASHBOARD_REPAIRS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DASHBOARD_REPAIRS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'dashboardRepairsData': action.data,
                'type': action.type
            });
        default:
            return state;
    }
};

export default dashboardReducer